import axios from 'axios';
class CommunicateInterceptor {
    static pendingRequests = {};
    static handleGetRequest(requestData) {
        const requestKey = this.getRequestKey(requestData);
        const pendingPromise = this.getPending(requestKey);
        return pendingPromise || this.createAndSaveRequest(requestKey, requestData);
    }
    static getRequestKey({ url, method, data }) {
        return `${url}${method}${JSON.stringify(data)}`;
    }
    static getPending(requestKey) {
        return this.pendingRequests[requestKey];
    }
    static createAndSaveRequest(requestKey, requestData) {
        const requestPromise = this.getRequestPromise(requestKey, requestData);
        this.pendingRequests[requestKey] = requestPromise;
        return requestPromise;
    }
    static getRequestPromise(requestKey, requestData) {
        const requestPromise = axios(requestData);
        return new Promise((resolve, reject) => {
            requestPromise.then((res) => {
                this.deletePending(requestKey);
                resolve(res);
            }).catch((err) => {
                this.deletePending(requestKey);
                reject(err);
            });
        });
    }
    static deletePending(requestKey) {
        delete this.pendingRequests[requestKey];
    }
}
export default CommunicateInterceptor;
